import { toastError } from '@components/Toast/Toast.tsx';
import type { RejectedFile } from '@gurupay/gp-ui-library';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const fileFailReason: Record<'FILE_TOO_LARGE' | 'FILE_TYPE_NOT_ALLOWED', string> = {
	FILE_TOO_LARGE: 'failDueToSize',
	FILE_TYPE_NOT_ALLOWED: 'failDueToFileType',
};

export const useRejectedFilesNotify = ({ size }: { size: number }) => {
	const { t } = useTranslation('', { keyPrefix: 'common' });

	const handleReject = useCallback(
		(rejectedFiles: RejectedFile[]) => {
			rejectedFiles.forEach((rejectedFile) => {
				toastError(
					t(
						fileFailReason?.[rejectedFile.reason as keyof typeof fileFailReason] ??
							'failToUpload',
						{ size },
					),
				);
			});
		},
		[t, size],
	);

	return { handleReject };
};
